require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\script-loader\\addScript.js")(require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\raw-loader\\index.js!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\ace-builds\\src-noconflict\\mode-batchfile.js"))


//////////////////
// WEBPACK FOOTER
// ./~/ace-builds/src-noconflict/mode-batchfile.js
// module id = 4410751445838611
// module chunks = 0